<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <!-- <jm-crumbs/> -->
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="英国文案流程" name="uk"></el-tab-pane>
            <el-tab-pane label="澳洲文案流程" name="aus"></el-tab-pane>
          </el-tabs>
          <!--英国部分列表条件 start-->
          <div class="is-uk searchList" v-if="this.country === 'uk'">
            <jm-toolbar
              ref="toolbarvm"
              customize-field-name="UkProcess"
              show-defined-search
              show-defined-list/>
            <div
              class="box-content"
              v-if="filterVisible('custom_name')">
              <label class="form-tit">姓名</label>
              <el-input
                v-model="searchData.custom_name"
                class="jm-input220"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('crm_tel')">
              <label class="form-tit">电话</label>
              <el-input
                v-model="searchData.crm_tel"
                class="jm-input220"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('crm_qq')">
              <label class="form-tit">QQ</label>
              <el-input
                v-model="searchData.crm_qq"
                class="jm-input220"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('shenqing_cailiao')">
              <label class="form-tit">申请材料</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.shenqing_cailiao"
                type="dataset"
                dict-type="student"
                name="ukShenqingCailiao"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('daili')">
              <label class="form-tit">代理方式</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.daili"
                type="online"
                dict-type="uk_daili" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('uk_applyfee')">
              <label class="form-tit">申请费用</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.uk_applyfee"
                type="online"
                dict-type="uk_applyfee" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('submit_school')">
              <label class="form-tit">递交校方</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.submit_school"
                type="dataset"
                dict-type="student"
                name="submitSchool" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('mianshi')">
              <label class="form-tit">面试</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.mianshi"
                type="online"
                dict-type="mianshi" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('offer_xiafa')">
              <label class="form-tit">申请结果</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.offer_xiafa"
                type="online"
                dict-type="offer_xiafa" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('get_offer_date_start')">
              <label class="form-tit">接受Offer截止开始日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.get_offer_date_start"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('get_offer_date')">
              <label class="form-tit">接受Offer截止结束日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.get_offer_date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('student_get_offer_date_start')">
              <label class="form-tit">学生接受Offer截止开始日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.student_get_offer_date_start"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('student_get_offer_date')">
              <label class="form-tit">学生接受Offer截止结束日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.student_get_offer_date"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('get_yanqi_offer_date_start')">
              <label class="form-tit">延期Offer接受截止开始日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.get_yanqi_offer_date_start"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('get_yanqi_offer_date')">
              <label class="form-tit">延期Offer接收截止结束日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.get_yanqi_offer_date"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('student_get_yanqi_offer_date_start')">
              <label class="form-tit">学生延期Offer接受截止开始日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.student_get_yanqi_offer_date_start"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('student_get_yanqi_offer_date')">
              <label class="form-tit">学生延期Offer接收截止结束日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.student_get_yanqi_offer_date"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('main_subject_money')">
              <label class="form-tit">正课押金金额</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.main_subject_money"
                type="online"
                dict-type="main_subject_money" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('main_subject_money_date')">
              <label class="form-tit">正课押金截止日</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.main_subject_money_date_end_is"
                type="dataset"
                dict-type="student"
                name="customPurpose" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('main_subject_money_date_end_start')">
              <label class="form-tit">正课押金截止开始日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.main_subject_money_date_end_start"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('main_subject_money_date_end')">
              <label class="form-tit">正课押金截止结束日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.main_subject_money_date_end"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('main_subject_money_date_start')">
              <label class="form-tit">正课押金支付开始日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.main_subject_money_date_start"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('main_subject_money_date_start_end')">
              <label class="form-tit">正课押金支付结束日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.main_subject_money_date_start_end"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('main_subject_money_pay')">
              <label class="form-tit">正课押金支付方式</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.main_subject_money_pay"
                type="online"
                dict-type="main_subject_money_pay" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('scholarship')">
              <label class="form-tit">奖学金</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.scholarship"
                type="dataset"
                dict-type="student"
                name="customPurpose" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('atas')">
              <label class="form-tit">ATAS</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.atas"
                type="dataset"
                dict-type="student"
                name="customPurpose" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('atas_date_start')">
              <label class="form-tit">ATAS开始日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.atas_date_start"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('atas_date')">
              <label class="form-tit">ATAS结束日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.atas_date"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('' +
              '')">
              <label class="form-tit">延期OFFER</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.yanqi"
                type="online"
                dict-type="yanqi" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange')">
              <label class="form-tit">语言申请</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.lange"
                type="online"
                dict-type="lange" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_week')">
              <label class="form-tit">语言时长</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.lange_week"
                type="dataset"
                dict-type="student"
                name="langeWeek" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_offer')">
              <label class="form-tit">语言OFFER</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.lange_offer"
                type="online"
                dict-type="lange_offer" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_pay_date_end_is')">
              <label class="form-tit">语言押金截止日</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.lange_pay_date_end_is"
                type="dataset"
                dict-type="student"
                name="customPurpose" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_pay_date_end_start')">
              <label class="form-tit">语言押金截止开始日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.lange_pay_date_end_start"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_pay_date_end')">
              <label class="form-tit">语言押金截止结束日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.lange_pay_date_end"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_pay_sell_date_start')">
              <label class="form-tit">语言押金支付开始日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.lange_pay_sell_date_start"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_pay_sell_date')">
              <label class="form-tit">语言押金支付结束日</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.lange_pay_sell_date"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_pay_sell_type')">
              <label class="form-tit">语言押金支付方式</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.lange_pay_sell_type"
                type="online"
                dict-type="main_subject_money_pay" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_cas')">
              <label class="form-tit">语言CAS</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.lange_cas"
                type="online"
                dict-type="lange_cas" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('un_con')">
              <label class="form-tit">Uncon-Offer</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.un_con"
                type="online"
                dict-type="un_con" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('class_cas')">
              <label class="form-tit">正课CAS</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.class_cas"
                type="online"
                dict-type="class_cas" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('is_t_over')">
              <label class="form-tit">是否终止</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                type="dataset"
                v-model="searchData.is_t_over"
                dict-type="student"
                name="isOver"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('crm_writer')">
              <label class="form-tit">老师</label>
              <el-select
                class="jm-input220"
                v-model="searchData.crm_writer"
                placeholder="请选择"
                clearable>
                <el-option-group
                  v-for="(group, k) in documentTeacher"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    :key="item.userid"
                    :label="item.truename"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('writer_time')">
              <label class="form-tit">分配时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.writer_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('sign_type')">
              <label class="form-tit">签约类型</label>
              <el-radio-group v-model="searchData.sign_type">
                <el-radio :label="1">Standard</el-radio>
                <el-radio :label="2">Plus</el-radio>
                <el-radio :label="3">Free</el-radio>
              </el-radio-group>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('schoolname')">
              <label class="form-tit">申请学校</label>
              <el-input
                v-model="searchData.schoolname"
                class="jm-input220"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('is_t_over_2')">
              <label class="form-tit">申请流程状态</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.is_t_over_2"
                type="dataset"
                dict-type="student"
                name="isOver2"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_cas_start_time')">
              <label class="form-tit">语言开课时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.lange_cas_start_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('class_cas_start_time')">
              <label class="form-tit">正课开课时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.class_cas_start_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('signing_date')">
              <label class="form-tit">签约时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.signing_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('kaixueqi_yearmonth')">
              <label class="form-tit">入学时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.kaixueqi_yearmonth"
                type="month"
                format="yyyy-MM"
                placeholder="请选择年月"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('submit_school_time')">
              <label class="form-tit">递交时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.submit_school_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
          </div>
          <!--英国部分 end-->
          <!--澳洲部分 start-->
          <div
            class="is-aus searchList"
            v-if="this.country === 'aus'&&this.searchData !== null">
            <jm-toolbar
              ref="toolbarvm"
              customize-field-name="AusProcess"
              show-defined-list
              show-defined-search/>
            <div
              class="box-content"
              v-if="filterVisible('custom_name')">
              <label class="form-tit">姓名</label>
              <el-input
                v-model="searchData.custom_name"
                class="jm-input220"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('custom_nickname')">
              <label class="form-tit">昵称</label>
              <el-input
                v-model="searchData.custom_nickname"
                class="jm-input220"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('crm_tel')">
              <label class="form-tit">电话</label>
              <el-input
                v-model="searchData.crm_tel"
                class="jm-input220"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('crm_qq')">
              <label class="form-tit">QQ</label>
              <el-input
                v-model="searchData.crm_qq"
                class="jm-input220"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('shenqing_cailiao')">
              <label class="form-tit">申请材料</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.shenqing_cailiao"
                empty-label="未开始"
                :empty-value="0"
                type="online"
                dict-type="shenqing_cailiao" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('daili')">
              <label class="form-tit">代理方式</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.daili"
                type="online"
                dict-type="aus_daili" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('mianshi')">
              <label class="form-tit">面试</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.mianshi"
                type="online"
                dict-type="mianshi" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('offer_xiafa')">
              <label class="form-tit">申请结果</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.offer_xiafa"
                empty-label="未开始"
                :empty-value="0"
                type="online"
                dict-type="aus_offer_xiafa" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('yanqi')">
              <label class="form-tit">延期</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.yanqi"
                type="dataset"
                dict-type="student"
                name="ausOfferXiafa" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange')">
              <label class="form-tit">语言是否通过</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.lange"
                type="dataset"
                dict-type="student"
                name="offerXiafaSwitch" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('un_con')">
              <label class="form-tit">un-con</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                empty-label="等待"
                :empty-value="0"
                v-model="searchData.un_con"
                type="online"
                dict-type="un_con" />
            </div>
            <div
              class="box-content"
              v-if="filterVisible('is_t_over')">
              <label class="form-tit">是否终止</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.is_t_over"
                type="dataset"
                dict-type="student"
                name="isOver"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('crm_writer')">
              <label class="form-tit">文案老师</label>
              <el-select
                class="jm-input220"
                v-model="searchData.crm_writer"
                placeholder="请选择"
                clearable>
                <el-option-group
                  v-for="(group, k) in documentTeacher"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    :key="item.userid"
                    :label="item.truename"
                    :value="item.userid"/>
                </el-option-group>
              </el-select>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('writer_time')">
              <label class="form-tit">分配时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.writer_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('sign_type')">
              <label class="form-tit">签约类型</label>
              <el-radio-group v-model="searchData.sign_type">
                <el-radio :label="1">Standard</el-radio>
                <el-radio :label="2">Plus</el-radio>
                <el-radio :label="3">Free</el-radio>
              </el-radio-group>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('schoolname')">
              <label class="form-tit">申请学校</label>
              <el-input
                v-model="searchData.schoolname"
                clearable
                class="jm-input220"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('is_t_over_2')">
              <label class="form-tit">申请流程状态</label>
              <jm-dict-select
                class="jm-input220"
                clearable
                v-model="searchData.is_t_over_2"
                type="dataset"
                dict-type="student"
                name="isOver2"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('lange_coe_start_time')">
              <label class="form-tit">语言开课时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.lange_coe_start_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('coe_start_time')">
              <label class="form-tit">正课开课时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.coe_start_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('signing_date')">
              <label class="form-tit">签约时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.signing_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('kaixueqi_yearmonth')">
              <label class="form-tit">入学时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.kaixueqi_yearmonth"
                type="month"
                format="yyyy-MM"
                placeholder="请选择年月"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('delay_yearmonth')">
              <label class="form-tit">延期入学时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.delay_yearmonth"
                type="month"
                format="yyyy-MM"
                placeholder="请选择年月"/>
            </div>
            <div
              class="box-content"
              v-if="filterVisible('submit_school_time')">
              <label class="form-tit">递交时间</label>
              <el-date-picker
                class="jm-input220"
                v-model="searchData.submit_school_time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"/>
            </div>
          </div>
          <!--澳洲部分 end-->
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => this.$store.commit('updateRefresh', true)">开始查询</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
          </div>
          <!--英国部分英国部分列表条件 end-->
          <!--列表部分 start 接口还未准备好-->
          <!--:span-method="spanMethod"-->
          <!--:modifier="dataModifier"-->
          <jm-tableList
            class="official-wapper"
            :url="this.getListurl"
            :refresh="refresh"
            :search-data="searchData"
            :span-method="spanMethod"
            :modifier="dataModifier"
          >
            <el-table-column
              slot="custom_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="custom_name">
              <template slot-scope="scope">
                <i
                  class="name-tip-l"
                  title="芥末注册用户"
                  v-if="scope.row.userid > 0"/>
                <span>{{ scope.row.custom_name }}</span>
                <span v-if="scope.row.custom_nickname_tell !== ''">/{{ scope.row.custom_nickname_tell }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="this.country === 'aus'"
              slot="lastColumn"
              label="操作">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  v-if="scope.row.crm_writer !== ''"
                  :to="{ name: 'details', params: { country: 'aus' ,crm_id:scope.row.crm_id, num:scope.row.num }}">
                  <el-button
                    type="primary"
                    size="small">查看</el-button>
                </router-link>
                <el-button
                  v-if="scope.row.crm_writer === ''"
                  @click="notgo()"
                  type="primary"
                  size="small">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column
              v-if="this.country === 'uk'"
              slot="lastColumn"
              label="操作">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  v-if="scope.row.crm_writer !== ''"
                  :to="{ name: 'details', params: { country: 'uk',crm_id:scope.row.crm_id, num:scope.row.num }}">
                  <el-button
                    type="primary"
                    size="small">查看</el-button>
                </router-link>
                <el-button
                  v-if="scope.row.crm_writer === ''"
                  @click="notgo()"
                  type="primary"
                  size="small">查看</el-button>
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import toolbar from '@/components/tool/toolbar.vue';
import { filterVisible, formatSelectGroupData } from '@/utils/utils';
import { jmDictSelect } from '@/components/tool';
import tableList from '@/components/data/tableList.vue';
import * as TeacherApi from '@/api/teacher.js';

const searchDataAus = {
  custom_name: '',
  custom_nickname: '',
  crm_tel: '',
  crm_qq: '',
  shenqing_cailiao: '',
  daili: '',
  mianshi: '',
  offer_xiafa: '',
  yanqi: '',
  lange: '',
  un_con: '',
  is_t_over: '',
  crm_writer: '',
  is_t_over_2: '',
  lange_coe_start_time: '',
  coe_start_time: '',
  writer_time: '',
  delay_yearmonth: '',
  origin_yearmonth: ''
};
const searchDataUk = {
  custom_name: '',
  crm_tel: '',
  crm_qq: '',
  shenqing_cailiao: '',
  daili: '',
  uk_applyfee: '',
  submit_school: '',
  submit_school_start: '',
  submit_school_end: '',
  mianshi: '',
  offer_xiafa: '',
  get_offer_date_start: '',
  get_offer_date: '',
  student_get_offer_date_start: '',
  student_get_offer_date: '',
  get_yanqi_offer_date_start: '',
  get_yanqi_offer_date: '',
  student_get_yanqi_offer_date_start: '',
  student_get_yanqi_offer_date: '',
  main_subject_money: '',
  main_subject_money_date_end_is: '',
  main_subject_money_date_end_start: '',
  main_subject_money_date_end: '',
  main_subject_money_date_start: '',
  main_subject_money_date_start_end: '',
  main_subject_money_pay: '',
  scholarship: '',
  atas: '',
  atas_date_start: '',
  atas_date: '',
  yanqi: '',
  lange: '',
  lange_week: '',
  lange_offer: '',
  lange_pay_date_end_is: '',
  lange_pay_date_end_start: '',
  lange_pay_date_end: '',
  lange_pay_sell_date_start: '',
  lange_pay_sell_date: '',
  lange_pay_sell_type: '',
  lange_cas: '',
  un_con: '',
  class_cas: '',
  is_t_over: '',
  crm_writer: '',
  lange_cas_tuition: '',
  lange_cas_start_time: '',
  class_cas_tuition: '',
  class_cas_start_time: '',
  writer_time: '',
  origin_yearmonth: ''
};
export default {
  data() {
    return {
      activeName: 'uk',
      a: '',
      tableListInited: false,
      country: '',
      documentTeacher: null,
      teacherId: '',
      searchData: null,
      dataTableInited: false,
      getListurl: null,
      nobegin: {
        value: '未开始',
        id: '0',
      }
    };
  },
  methods: {
    filterVisible,
    resetFields() {
      this.research1 = '';
      Object.keys(this.searchData).forEach((k) => {
        this.searchData[k] = null;
      });
    },
    whichCountry(country = 'uk') {
      this.country = country;
      if (this.country === 'aus') {
        this.activeName = 'aus';
        this.teacherId = 28;
        this.getListurl = '/index/aus_process/pagetable';
        this.searchData = searchDataAus;
      } else {
        this.teacherId = 26;
        this.searchData = searchDataUk;
        this.getListurl = '/index/uk_process/pagetable';
      }
    },
    notgo() {
      this.$message.warning('分配文案老师后，才可查看');
    },
    spanMethod({ row, columnIndex }) {
      if (columnIndex <= 3) {
        if (row.flag === true) {
          return {
            rowspan: row.plength,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0
        };
      }
    },
    dataModifier(data) {
      let newData = [];
      data.data.forEach((item) => {
        let plength = item.processList.length;
        for (let i = 0; i < plength; i++) {
          let process = item.processList[i];
          newData.push({
            ...item, ...process, id: item.id, sid: process.id, plength, flag: i === 0, num: i
          });
        }
      });
      data.data = newData;
      return data;
    },
    handleClick(tab) {
      this.whichCountry(tab.name);
      TeacherApi.getTeachers(this.teacherId).then(({ data }) => {
        this.documentTeacher = formatSelectGroupData(data);
      });
      this.$store.commit('updateRefresh', true);
    }

  },
  mounted() {
    this.whichCountry();
    // aus28 uk26
    TeacherApi.getTeachers(this.teacherId).then(({ data }) => {
      this.documentTeacher = formatSelectGroupData(data);
    });
  },
  computed: {
    refresh() {
      return this.$store.state.student.refresh;
    },
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-toolbar': toolbar,
    jmDictSelect,
    'jm-tableList': tableList
  },
};
</script>
<style scoped>
  .name-tip-l{
    display: inline-block;
    width: 5px;
    height: 15px;
    background-color: #3368fa;
    margin-top: 5px;
    border-radius: 2px;
    margin-right: 5px;
  }
</style>
<style>
  .official-wapper .el-table__row>td:nth-last-of-type(1) .el-button{
    display: block;
    margin: 0 auto;
  }
</style>
